var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.42301 2.30841C6.42301 1.58879 7.03566 1 7.78444 1C8.53323 1 9.12318 1.58879 9.12318 2.30841C9.12318 3.02804 7.78444 3.31153 7.78444 4.05296L1 7.54206C1 7.78193 1.18152 8 1.43112 8H14.5689C14.7958 8 15 7.80374 15 7.54206L8.21556 4.29284",
    stroke: "#00E194"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC13);
export default __webpack_public_path__ + "static/media/c13.52259bb6dcf3e320af168fce75c2c09b.svg";
export { ForwardRef as ReactComponent };